<template>
    <div class="riskList flex flex-direction">
        <div class="table-box flex-sub">
            <div class="title">
                <div class="flex justify-start align-center">
                    <div class="icon-box">
                        <i class="iconfont icon-xingxing"></i>
                    </div>
                    <b>星级评定详情</b>
                </div>
                <div class="page-cancel" @click="$router.go(-1)">
                    <i class="icon iconfont icon-jiantouzuo1"></i>返回
                </div>
            </div>
            <div class="table">
                <div v-for="(item,index) in lists" :key="item.id">
                    <div class="title-tex">{{ item.name }}（{{ item.score }}分）</div>
                    <el-table
                        :cell-style="textCenter"
                        :data="item.child"
                        :header-cell-style="centerbgc"
                        :span-method="(params)=>arraySpanMethod(params,index)"
                        border
                        style="width: 100%">
                        <el-table-column
                            label="二级指标"
                            width="250">
                            <template slot-scope="scope">
                                {{ scope.row.one_title }}（{{ scope.row.one_score }}分）
                            </template>
                        </el-table-column>

                        <el-table-column
                            label="三级指标"
                            width="250">
                            <template slot-scope="scope">
                                {{ scope.row.two_title }}（{{ scope.row.two_score }}分）
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="评分规则">
                            <template slot-scope="scope">
                                <p v-for="(itm,idx) in scope.row.child" :key="idx"
                                   :class="{red:scope.row.red_key.indexOf((idx + 1)) != -1}"
                                   class="texscore">{{ itm }}</p>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="分项得分"
                            width="150">
                            <template slot-scope="scope">
                                {{ scope.row.two_get_score }}分
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="总分"
                            width="150">
                            <template slot-scope="scope">
                                {{ scope.row.one_get_score }}分
                            </template>
                        </el-table-column>
                    </el-table>
                    <div v-if="index == lists.length - 1" class="sum">总分：{{ item.getScore }}分</div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>

import {getEvaluateOrgDetail} from "@/api/admin";

export default {
    name: "evaluateList",
    data() {
        return {
            oid: '',
            id: '',
            column_1: [],
            pos_1: 0,
            column_2: [],
            pos_2: 0,
            tableData: [],
            lists: [],
        }
    },
    components: {},
    computed: {
        textCenter() {
            return {
                textAlign: 'center',
                fontSize: '15px'
            }
        },
        centerbgc() {
            return {
                textAlign: 'center',
                color: '#444444',
                fontSize: '16px'
            }
        }
    },
    created() {
        this.oid = this.$route.query.oid
        this.id = this.$route.query.id
        this.$emit("setActive", {
            headActive: 3
        })
        this.list()
    },
    methods: {
        async list() {
            let _data = await getEvaluateOrgDetail(this.oid, this.id);
            if (_data.status == 200) {
                this.tableData = _data.data.line
                let ary
                this.tableData.map(item => {
                    ary = []
                    item.child.map(one => {
                        one.child.map(two => {
                            ary.push(this.customData(one.id, one.title, one.score, one.get_score, two.title, two.score, two.child, two.get_score, two.red_key.map(Number)))
                        })
                    })
                    this.lists.push({
                        id: item.id,
                        name: item.title,
                        score: item.score,
                        getScore: _data.data.score,
                        child: ary
                    })
                })

                this.lists.map((item, index) => {
                    this.getSpanArr(item.child, index)
                })
              console.log('this.lists')
              console.log(this.lists)
            }
        },

        customData(id, one_title, one_score, one_get_score, two_title, two_score, child, two_get_score, red_key) {
            return {
                id,
                one_title,
                one_score,
                one_get_score,
                two_title,
                two_score,
                child,
                two_get_score,
                red_key,
            }
        },
        getSpanArr(data, idx) {
            if (idx == 0) {
                this.column_1 = []
                for (let i = 0; i < data.length; i++) {
                    if (i === 0) {
                        this.column_1.push(1);
                        this.pos_1 = 0
                    } else {
                        // 判断当前元素与上一个元素是否相同
                        if (data[i].id === data[i - 1].id) {
                            this.column_1[this.pos_1] += 1;
                            this.column_1.push(0);
                        } else {
                            this.column_1.push(1);
                            this.pos_1 = i;
                        }
                    }
                }
            }
            if (idx == 1) {
                this.column_2 = []
                for (let i = 0; i < data.length; i++) {
                  if (i === 0) {
                    this.column_2.push(1);
                    this.pos_2 = 0
                  } else {
                    // 判断当前元素与上一个元素是否相同
                    if (data[i].id === data[i - 1].id) {
                      this.column_2[this.pos_2] += 1;
                      this.column_2.push(0);
                    } else {
                      this.column_2.push(1);
                      this.pos_2 = i;
                    }
                  }
                    // if (i === 0) {
                    //     this.column_2.push(1);
                    //     this.pos_2 = 0
                    // } else {
                    //     this.column_2[this.pos_2] += 1;
                    //     this.column_2.push(0);
                    // }
                }
            }
        },
        arraySpanMethod({rowIndex, columnIndex}, index) {
            if (index == 0) {
                if (columnIndex === 0 || columnIndex === 4) {
                    const _row = this.column_1[rowIndex];
                    const _col = _row > 0 ? 1 : 0;
                    return { // [0,0] 表示这一行不显示， [2,1]表示行的合并数
                        rowspan: _row,
                        colspan: _col
                    }
                }
            }
            if (index == 1) {
                // if (columnIndex === 4) {
                //     const _row = this.column_2[rowIndex];
                //     const _col = _row > 0 ? 1 : 0;
                //     return { // [0,0] 表示这一行不显示， [2,1]表示行的合并数
                //         rowspan: _row,
                //         colspan: _col
                //     }
                // }
              if (columnIndex === 0 || columnIndex === 4) {
                const _row = this.column_2[rowIndex];
                const _col = _row > 0 ? 1 : 0;
                return { // [0,0] 表示这一行不显示， [2,1]表示行的合并数
                  rowspan: _row,
                  colspan: _col
                }
              }
            }
        },

    },
    watch: {},
    filters: {}
}
</script>

<style lang="scss" scoped>
.table-box {
    width: 100%;
    background-image: linear-gradient(0deg,
        #ffffff 84%,
        #edf6ff 100%);
    padding: 0 20px;
    border-radius: 10px;
}
.riskList {
    width: 100%;
    height: 100%;
    min-height: calc(100vh - (173px + 159px));
    background: #f3f5f7;
    padding: 20px;

    .sum {
        width: 100%;
        height: 80px;
        line-height: 80px;
        text-align: center;
        font-weight: bold;
        font-size: 17px;
        color: #000000;
        border: 1px solid #EBEEF5;
        border-top: none;
    }

    .red {
        color: #f74945;
    }

    .texscore {
        width: 100%;
        text-align: center;
        line-height: 24px;
    }

    .table {
        width: 100%;
        margin: 30px 10px;

        .title-tex {
            width: 100%;
            padding: 20px;
            text-align: center;
            font-size: 18px;
            color: #000000;
            font-weight: bold;
            background: #f3f5f7;
        }

        .titChild {
            font-weight: bold;
            font-size: 16px;
            color: #333333;
        }

        table {
            border-color: #333;
        }

        td {
            text-align: center;
            padding: 10px;
            font-size: 15px;
            color: #555555;
        }
    }

    .title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 60px;
        border-bottom: 2px solid #e3e7f0;

        b {
            font-size: 22px;
            color: #16181d;
            font-weight: bold;
            margin-left: 10px;
        }

        .icon-box {
            width: 30px;
            height: 30px;
            background-image: linear-gradient(-30deg,
                #3579fb 0%,
                #44a3ff 100%);
            box-shadow: 0px 10px 10px 0px rgba(50, 150, 255, 0.3);
            border-radius: 10px;
            text-align: center;
            line-height: 30px;

            i {
                font-size: 20px;
                color: #ffffff;
            }
        }
    }
}
</style>


